import api from './core';
import { Address, AddressDetail } from './types';
import { normalizePaginatedResponse, type PaginatedResponse } from './pagination';

export interface GetAddressesParams {
  site_id?: string | number;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export const getAddresses = async (
  filters?: GetAddressesParams,
  signal?: AbortSignal
): Promise<PaginatedResponse<Address>> => {
  const params = new URLSearchParams();
  if (filters?.site_id != null) params.append('site_id', String(filters.site_id));
  if (filters?.ordering) params.append('ordering', filters.ordering);
  if (filters?.limit != null) params.append('limit', String(filters.limit));
  if (filters?.offset != null) params.append('offset', String(filters.offset));

  const queryString = params.toString();
  const url = queryString ? `/crm/addresses/?${queryString}` : '/crm/addresses/';

  const response = await api.get(url, { signal });
  return normalizePaginatedResponse(response.data);
};

export const getAddress = async (
  id: string | number,
  signal?: AbortSignal
): Promise<AddressDetail> => {
  const response = await api.get(`/crm/addresses/${id}/`, { signal });
  return response.data;
};

export const createAddress = async (data: Partial<Address>): Promise<Address> => {
  const response = await api.post('/crm/addresses/', data);
  return response.data;
};

export const updateAddress = async (id: string, data: Partial<Address>): Promise<Address> => {
  const response = await api.patch(`/crm/addresses/${id}/`, data);
  return response.data;
};

export const deleteAddress = async (id: string): Promise<void> => {
  await api.delete(`/crm/addresses/${id}/`);
};
